var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[_c('NavBar',{attrs:{"title":"问题详情","routeUrl":"/myTicket"}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail-page"},[_c('div',{staticClass:"detail-title"},[_vm._v("什么时候开新服")]),_c('div',{staticClass:"detail-content"},[_c('p',[_vm._v(" 开服时间是策划大大根据游戏实际运营情况进行安排的，目前客服也无法提前获取的哦~~ ")]),_c('p',[_vm._v("建议您多留意游戏内公告或邮件开服信息~")])])])
}]

export { render, staticRenderFns }